<h4
  [appLayout]="layoutService.baseColorButtons"
  (click)="this.epanded = !this.epanded"
  [appLayoutColorFlip]="true"
>
  @if (epanded) {
  <i class="ri-arrow-up-s-line"></i>
  }
  @if (!epanded) {
  <i class="ri-arrow-down-s-line"></i>
  }
  {{event.timeblock.name}}
</h4>

@if (epanded) {
<div class="mt-3 ">
  @for (document of event.participantSummaryDocuments; track document) {
  <div class="row mb-5">
    <div class="col-6">
      <div class="row">
        <div class="col-6 ">
          <a
            class="d-block  text-center"
            [routerLink]="getRouterLinkToSingleDocView(event, document)"
          >
            <img
              alt="Thumbnail summary-timeblock"
              class="img-fluid img-thumbnail"
              style="background-color: #fff"
              [src]="'/api/pdf/getpage/' + document._id + '/0' | secure | async"
            >
            <span style="color:#232E55">
              {{document.metadata.docname}} ({{document.metadata.pagescount}})
            </span>
          </a>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div
        i18n="@@ratingNotes"
        class="div alert alert-notice-header"
        [style.backgroundColor]="layoutService.gray50.backgroundColor"
      >
        Notizen
      </div>
      @if (mycomments && mycomments[document?._id] != undefined) {
      <div>
        @for (idx of counter(document.metadata.pagescount); track idx; let p = $index) {
        @if (mycomments[document._id][p]) {
        <div>
          <div class="d-flex">
            <i
              class="ri-message-2-fill mr-2"
              [appLayout]="layoutService.activeColor"
              style="transform: scaleX(-1)"
              [appLayoutColorFlip]="true"
            ></i>
            <b
              i18n="@@summaryPage"
              style="font-weight: bold"
            >Seite</b> {{p + 1}}:
          </div>
          @if (mycomments[document._id][p]) {
          <div
            [innerHTML]="mycomments[document._id][p]"
            style="margin-left: 24px "
            class="pl-2"
            [appLayout]="layoutService.textColor50"
          ></div>
          }
        </div>
        }
        }
      </div>
      }
    </div>
  </div>
  }
  <div class="row">
    <div class="col-12">
      <div class="row text-left ">
        <div class="col-12">
          @if (event.notes.length > 0) {
          <div class="card mb-2 ">
            <div
              i18n="@@summaryGeneralNotes"
              class="card-header"
              [appLayout]="layoutService.baseColorButtons"
            >
            </div>
            <div class="card-body">
              @for (notes of event.notes; track notes) {
              <div [innerHTML]="notes"></div>
              }
            </div>
          </div>
          }
        </div>
      </div>
      <div class="row text-left pt-2">
        @if (event.strengths.length > 0) {
        <div class="col-6">
          <div class="card mb-2">
            <div
              i18n="@@summaryStrengths"
              class="card-header"
              [appLayout]="layoutService.baseColorButtons"
            >
              Stärken
            </div>
            <div class="card-body">
              @for (strength of event.strengths; track strength) {
              <div [innerHTML]="strength"></div>
              }
            </div>
          </div>
        </div>
        }
        @if (event.developmentAreas.length > 0) {
        <div class="col-6">
          <div class="card mb-2">
            <div
              i18n="@@summaryDevelopmentAreas"
              class="card-header"
              [appLayout]="layoutService.baseColorButtons"
            >
              Entwicklungsfelder
            </div>
            <div class="card-body">
              @for (developmentArea of event.developmentAreas; track developmentArea) {
              <div [innerHTML]="developmentArea"></div>
              }
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
}